export default "__VITE_PUBLIC_ASSET__857747d3__"